import styled from 'styled-components'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'

export const PromoCodeButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 6px;
  border: 1px solid ${myPalette.dark.drawerTopLine};
  background-color: ${myPalette.white.main};
  color: ${myPalette.midnightBlue.primary};
  font-size: 17px;
  font-weight: 400;
  padding: 14px 16px;
  cursor: pointer;
  margin-top: 16px;
  height: 56px;
`

export const PercentIconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background-color: ${myPalette.blue.primaryLightest};
  border-radius: 6px;
`

export const ButtonTitle = styled.div`
  font-size: 16px;
  color: ${myPalette.midnightBlue.main};
  white-space: nowrap;
  line-height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DrawerTitle = styled.div`
  font-size: 22px;
  color: ${myPalette.midnightBlue.main};
  font-weight: 700;
  line-height: 100%;
`

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const SubmitButton = styled(Button)`
  height: 56px;
`
export const SuccessMessage = styled.div`
  font-size: 12px;
  color: ${myPalette.blue.main};
  margin: 0;
`

export const IconButton = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
`
